module.exports = __webpack_public_path__ + "media/images/talent/case3-icon01-b2fd7b16596fecb975dfc4201434d38f.png";